function WinIcon() {
	return (
		<svg
			width="82"
			height="80"
			viewBox="0 0 82 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M81.0776 45.0558C82.4374 53.2428 78.0096 61.3269 72.2775 67.3259C66.7974 73.0613 59.0695 75.1608 51.2189 76.305C42.4636 77.5811 33.6407 78.1656 25.7787 74.1033C15.2929 68.6851 3.15827 62.125 1.23937 50.4801C-0.746037 38.4316 8.33424 27.7279 16.6664 18.8052C24.6541 10.2514 34.6742 0.155887 46.1699 2.36518C57.2196 4.48875 58.6629 19.5337 65.7862 28.2452C70.771 34.3413 79.7874 37.2884 81.0776 45.0558Z"
				fill="#2E8DDB"
			/>
			<g opacity="0.34">
				<path
					d="M40.302 48.7607V52.9607"
					stroke="white"
					strokeWidth="2.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M30.302 59.7607H50.302V57.7607C50.302 55.5607 48.502 53.7607 46.302 53.7607H34.302C32.102 53.7607 30.302 55.5607 30.302 57.7607V59.7607V59.7607Z"
					stroke="white"
					strokeWidth="2.5"
					strokeMiterlimit="10"
				/>
			</g>
			<path
				d="M28.3015 59.7607H52.3015"
				stroke="white"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M40.0017 47.7607C32.2617 47.7607 26.0017 41.5007 26.0017 33.7607V27.7607C26.0017 23.3407 29.5817 19.7607 34.0017 19.7607H46.0017C50.4217 19.7607 54.0017 23.3407 54.0017 27.7607V33.7607C54.0017 41.5007 47.7417 47.7607 40.0017 47.7607Z"
				stroke="white"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.34"
				d="M26.9418 39.0609C25.4418 38.5809 24.1218 37.7009 23.0818 36.6609C21.2818 34.6609 20.0818 32.2609 20.0818 29.4609C20.0818 26.6609 22.2818 24.4609 25.0818 24.4609H26.3818C25.9818 25.3809 25.7818 26.4009 25.7818 27.4609V33.4609C25.7818 35.4609 26.2018 37.3409 26.9418 39.0609Z"
				stroke="white"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.34"
				d="M53.061 39.0609C54.561 38.5809 55.881 37.7009 56.921 36.6609C58.721 34.6609 59.921 32.2609 59.921 29.4609C59.921 26.6609 57.721 24.4609 54.921 24.4609H53.621C54.021 25.3809 54.221 26.4009 54.221 27.4609V33.4609C54.221 35.4609 53.801 37.3409 53.061 39.0609Z"
				stroke="white"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default WinIcon;
